export default __webpack_public_path__ + "static/media/six.38edb2d6.png";